import { objectOf, arrayOf, recordOf, tupleOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPageStatsResult = objectOf({
  impressions: number,
  form_submissions: number,
  clicks: number,
  clicks_by_click_id: recordOf({ key: string, value: number }),
  daily_clicks_by_click_id: recordOf({ key: string, value: arrayOf(tupleOf(number, number)) }),
});
